export const ADD_FILES = "ADD_FILES";
